import { ChangeDetectorRef, Component, HostListener, Input, Optional, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { LoginModel } from 'src/app/models/login.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { faX, faAngleLeft, faEllipsisVertical } from '@fortawesome/free-solid-svg-icons'; // O far para regular
import { RegisterComponent } from 'src/app/components/modals/register/register.component';
import { RecoverPasswordComponent } from 'src/app/components/modals/recover-password/recover-password.component';
import { InfoMessageService } from 'src/app/services/info-message.service';
import { AddAddressModel } from 'src/app/models/add-address.model';
import { ProductAddedToCartComponent } from '../product-added-to-cart/product-added-to-cart.component';
import { InputSelectComponent } from '../../inputs/input-select/input-select.component';

@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss']
})
export class AddAddressComponent {
  @Input() title = '';
  @Input() msg = '';
  @Input() btn_msg_yes = '';
  @Input() btn_msg_no = '';
  @Input() callback_yes = () => { };
  @Input() callback_no = () => { };
  @ViewChild('citySelect') citySelect!: InputSelectComponent;
  previousAddAddressFormGroup: RxFormGroup;
  addAddressFormGroup: RxFormGroup;
  loginCarg = false;
  faClose = faX;
  faAngleLeft = faAngleLeft;
  faEllipsisVertical = faEllipsisVertical;
  typePassword: boolean = true; // Or initialize as needed
  modalCarga?: NgbModalRef;
  ngbModalOptions: NgbModalOptions = {
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  listDepartament: any[] = [];
  listCities: any[] = [];
  showAddressForm: boolean = true;
  addressOptions: any[] = [];
  isEdition: boolean = false;
  tempAddress: any = {};
  infoUser: any;

  constructor(
    @Optional() public activeModal: NgbActiveModal,
    private fb: RxFormBuilder,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private messageService: InfoMessageService,
    public auth: AuthService,
  ) { 
    const addAddressModel = new AddAddressModel();
    this.addAddressFormGroup = (this.fb.formGroup(addAddressModel) as RxFormGroup);
    this.previousAddAddressFormGroup = (this.fb.formGroup(addAddressModel) as RxFormGroup);
  }

  async ngOnInit(): Promise<void> {
    if(!this.isInsideModal()){
      this.loginCarg = true;
      this.showAddressForm = false;
    }
    
    if(this.isEdition){
      await this.loadDepartments();
    }

    if(this.showAddressForm){
      await this.initForm();
    }
    else{
      this.infoUser = await this.auth.getUserData();
      await this.getUserAddresses(this.infoUser.data_user.id);
    }

    await this.loadDepartments();
    this.loginCarg = false;
  }

  private async loadDepartments(): Promise<void> {
    this.listDepartament = await this.auth.getDepartmentFromServerImagine();
  }

  async initForm(): Promise<void> {
    return new Promise((resolve) => {
      const addAddressModel = new AddAddressModel();
      this.addAddressFormGroup = (this.fb.formGroup(addAddressModel) as RxFormGroup);
      this.addAddressFormGroup.get('department').setValue('');
      this.addAddressFormGroup.get('city').setValue('');
      resolve();
    });
  }
  
  onYes() {
    this.activeModal.close('login');
    this.callback_yes();
    window.location.reload()
  }

  onNo() {
    this.activeModal.close('dismiss');
  }

  onEmailInput(eventData: any){
    const inputElement = eventData.target as HTMLInputElement;
    const value = inputElement.value;

    const isNumber = this.isNumber(value);

    if(isNumber && value.length > 10){
      this.addAddressFormGroup.get('email')?.setValue(
        inputElement.value.substring(0,10)
      );
    }
  }

  isNumber(value: string){
    return /^-?\d*\.?\d+$/.test(value);
  }

  // ngOnDestroy(){
  //   this.messageService.hideActiveMessage();
  // }

  async onDepartamentoChange(department: any = null) {
    if(this.addAddressFormGroup){
      this.addAddressFormGroup.get('city')?.setValue('');
    }
    const selectedDepartment = department ? department : this.addAddressFormGroup.get('department')?.value;
    await this.loadCitiesForDepartment(selectedDepartment);
  }

  async loadCitiesForDepartment(department: string) {
    if(this.citySelect){
      this.citySelect.customOptionSelected('');
    }
    const selectedDepartment = this.listDepartament.find(
      (dep) => dep.name === department
    );
    if (selectedDepartment) {
      const departmentCode = selectedDepartment.code;
      this.listCities = await this.auth.getCitiesFromServerImagine(departmentCode);
    } else {
      this.listCities = [];
    }

    
  }

  returnToFirstMessage(){
    this.activeModal.close('return');
  }

  registerAddress(){
    this.loginCarg = true;
    const userData = this.authService.getUserData();
    const userId = userData.data_user.id;
    
    if(this.isEdition){
      this.authService.updateAddress(userId, this.tempAddress._id, this.addAddressFormGroup.value).subscribe({
        next: async (response) => {
          if(this.isInsideModal()){
            this.activeModal.close('close');
          }
          else{
            this.showAddressForm = false;
          }
          this.messageService.showMessage(
            "¡Dirección actualizada!",
            "La dirección ha sido editada exitosamente.",
            "success"
          );

          this.isEdition = false;
          this.tempAddress = {};
          if(Object.keys(this.infoUser).length > 0){
            await this.getUserAddresses(this.infoUser.data_user.id);
          }

          this.loginCarg = false;
          // this.authService.setNotifyDirectionAdded(true);
        },
        error: (error) => {
          this.loginCarg = false;
          console.error('Registro falló', error);
        }
      });
    }
    else{
      this.authService.registerAddress(userId, this.addAddressFormGroup.value).subscribe({
        next: async (response) => {
          if(this.isInsideModal()){
            this.loginCarg = false;
            this.activeModal.close('close');
          }
          else{
            this.showAddressForm = false;
            this.messageService.showMessage(
              "¡Dirección agregada!",
              "La dirección ha sido guardada exitosamente.",
              "success"
            );
  
            if(Object.keys(this.infoUser).length > 0){
              await this.getUserAddresses(this.infoUser.data_user.id);
            }
  
            this.loginCarg = false;
          }
          // this.authService.setNotifyDirectionAdded(true);
        },
        error: (error) => {
          this.loginCarg = false;
          console.error('Registro falló', error);
        },
        complete: () => {
          this.loginCarg = false;
        }
      });
    }
  }

  isInsideModal(): boolean {
    return !!this.activeModal;
  }

  async toggleAddressForm(){
    this.messageService.hideActiveMessage();
    this.showAddressForm = true;
    await this.initForm();
    await this.onDepartamentoChange();
  }

  getUserAddresses(id: any): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.auth.getDataUser(id).subscribe({
        next: (data: any) => {
          this.addressOptions = data?.address?.map((address: any) => ({
            ...address,
            showDropdown: false
          }));
          resolve(this.addressOptions || []);
        },
        error: (error) => {
          this.loginCarg = false;
          reject(error);
        }
      });
    });
  }

  toggleDropdown(address: any) {
    this.addressOptions.forEach(addr => {
      if (addr !== address) {
        addr.showDropdown = false;
      }
    });
    
    address.showDropdown = !address.showDropdown;
  }

  closeAllDropdowns() {
    this.addressOptions.forEach(address => {
      address.showDropdown = false;
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const isMenuButton = (event.target as Element).closest('.addres-container-header > div');
    
    const isInsideDropdown = (event.target as Element).closest('.address-dropdown');
    
    if (!isMenuButton && !isInsideDropdown) {
      this.closeAllDropdowns();
    }
  }

  async editAddress(address: any) {
    this.messageService.hideActiveMessage();
    this.loginCarg = true;
    this.closeAllDropdowns();
    this.isEdition = true;
    this.tempAddress = address;
    await this.onDepartamentoChange(address.department);
    this.showAddressForm = true;
    await this.initForm();
    const addressData = {
      name: this.tempAddress.name,
      address: this.tempAddress.address,
      department: this.tempAddress.department,
      city: this.tempAddress.city
    };
    this.addAddressFormGroup.patchValue(addressData);
    this.previousAddAddressFormGroup.patchValue(addressData);
    this.loginCarg = false;
  }

  compareFormGroups(): boolean {
    return JSON.stringify(this.addAddressFormGroup.value) === 
           JSON.stringify(this.previousAddAddressFormGroup.value);
  }
  

  disableEdition(){
    this.loginCarg = true;
    this.isEdition = false;
    this.showAddressForm = false;
    this.tempAddress = {};
    this.loginCarg = false;
  }

  deleteAddress(address: any){
    this.messageService.hideActiveMessage();
    const userData = this.authService.getUserData();
    const userId = userData.data_user.id;
    this.closeAllDropdowns();
    this.modalCarga = this.modalService.open(
        ProductAddedToCartComponent,
        this.ngbModalOptions
    );
    this.modalCarga.componentInstance.title = "¿Quieres eliminar esta dirección?";
    this.modalCarga.componentInstance.textFirstButton = 'Eliminar';
    this.modalCarga.componentInstance.textSecondButton = 'Cancelar';
    this.modalCarga.componentInstance.firstButtonAction = () => {
      this.loginCarg = true;
      this.authService.deleteAddress(userId, address._id).subscribe({
        next: async (response) => {
          this.modalCarga.close('close');

          this.messageService.showMessage(
            "¡Dirección eliminada!",
            "La dirección ha sido eliminada exitosamente.",
            "success"
          );

          if(Object.keys(this.infoUser).length > 0){
            await this.getUserAddresses(this.infoUser.data_user.id);
          }

          this.loginCarg = false;
        },
        error: () => {
          this.loginCarg = false;
        }
      });
    };
    this.modalCarga.componentInstance.secondButtonAction = () => {
      this.modalCarga.close('close');
    };
  }
}